module.exports = __webpack_public_path__ + "static/3_2_Bayes-Rule_2_BG-2dd9d17fd0b97faf54f8afd2fb21287e.svg";